const mode = 'PROD';

const IMAGE_BASE_URL = mode === 'PROD' ? 'https://api.globalindiarealestate.com/' : 'https://agentnetwork.vytech.co/';
const BASE_URL = mode === 'PROD' ? 'https://api.globalindiarealestate.com/ws' : 'https://agentnetwork.vytech.co/ws';
const WS_URL = mode === 'PROD' ? 'wss://api.globalindiarealestate.com/wss2/:8090' : 'wss://agentnetwork.vytech.co/wss2/:8090';
module.exports = {
    IMAGE_BASE_URL,
    BASE_URL,
    WS_URL
};